module.exports = __webpack_public_path__ + "img/xqfw3.87e990b6.png";